import { ccfRoutes } from '@app/ccf/ccf-routes';
import Text from '@shared/components/content/text';
import GuideTemplate from '@shared/components/guide-template';
import { useFormContext } from 'react-hook-form';
import { generatePath, useNavigate, useOutletContext } from 'react-router-dom';
import DistributionFlowForm from '../components/distribution-flow-form';
import { DistributionFlowContext } from '../distribution-flow-layout';
import { useCCF } from '../../ccf-context';

export default function DistributionFlowReviewPage() {
  const navigate = useNavigate();
  const { uuid: reportUuid } = useCCF();
  const { trigger } = useFormContext();

  const context = useOutletContext<DistributionFlowContext>();
  const { flowUuid } = context;

  const onNext = async () => {
    const isValid = await trigger('segments');

    if (isValid) {
      navigate(
        generatePath(ccfRoutes.DISTRIBUTION_FLOW_ADD_WEIGHT, {
          report_uuid: reportUuid,
          flow_uuid: flowUuid || '',
        })
      );
    }
  };

  return (
    <GuideTemplate
      preTitle="ADD DISTRIBUTION FLOW"
      title="Review flow"
      description={
        <Text>
          We&apos;ve generated a flow for you below, trying to model the average
          journey that your products take to reach consumers. You can add or
          amend the steps if you have more accurate information available.
        </Text>
      }
      primaryActionText="Next"
      primaryActionProps={{ onClick: onNext }}
      secondaryActionText="Back"
      secondaryActionProps={{
        onClick: () =>
          navigate(
            generatePath(ccfRoutes.DISTRIBUTION_FLOW_ABOUT_CLIENTS, {
              report_uuid: reportUuid,
              flow_uuid: flowUuid || '',
            })
          ),
      }}
    >
      <DistributionFlowForm />
    </GuideTemplate>
  );
}
